import { useCallback } from "react";
import { useUpdateUserMutation } from "../../../../hooks/queries/useProfileQueries";
import { toastService } from "../../../../providers";

export const useUserHandlers = ({
  modalMode,
  selectedUser,
  closeModal,
  createUser,
}) => {
  const { mutate: UpdateUser, isPending: isUpdating } = useUpdateUserMutation();

  const onSubmit = useCallback(
    (values) => {
      if (modalMode === "create" && createUser) {
        createUser(values, {
          onSuccess: () => {
            toastService.success("User created successfully!");
            closeModal();
          },
          onError: () => {
            toastService.error("Failed to create user");
          },
        });
      } else {
        UpdateUser(
          { userId: selectedUser.id, userData: values },
          {
            onSuccess: () => {
              toastService.success("User updated successfully!");
              closeModal();
            },
            onError: () => {
              toastService.error("Failed to update user");
            },
          },
        );
      }
    },
    [modalMode, selectedUser, createUser, UpdateUser, closeModal],
  );

  return {
    onSubmit,
    isUpdating,
  };
};

export default useUserHandlers;
